import ResourcePage from "@/components/common/ResourcePage";
import { useMeta } from "@/context/MetaContext";
import { StatusBadge } from "@/components/common/StatusBadge";
import { money } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Expenses() {
  const { options, outletOptions, outletName } = useMeta();
  const { user } = useAuth();
  const isSuper = user?.role === "super_admin" || user?.role === "finance";

  const fields = [
    { name: "date", label: "Date", type: "date", span: 1, required: true, default: new Date().toISOString().slice(0, 10) },
    ...(isSuper ? [{ name: "outlet_id", label: "Outlet", type: "select", span: 1, options: outletOptions, required: true }] : []),
    { name: "category", label: "Category", type: "select", span: 1, options: options("expense_category"), required: true },
    { name: "department", label: "Department", type: "select", span: 1, options: options("department") },
    { name: "vendor", label: "Vendor / Payee", span: 1 },
    { name: "amount", label: "Amount", type: "number", span: 1, step: "0.01", required: true },
    { name: "paid_amount", label: "Paid Amount", type: "number", span: 1, step: "0.01", default: 0 },
    { name: "notes", label: "Notes", type: "textarea" },
  ];
  const columns = [
    { key: "date", label: "Date", sortable: true, render: (r) => <span className="tabular">{r.date}</span> },
    { key: "outlet_id", label: "Outlet", render: (r) => outletName(r.outlet_id) },
    { key: "category", label: "Category", render: (r) => <span className="font-medium">{r.category}</span> },
    { key: "department", label: "Dept." },
    { key: "amount", label: "Amount", sortable: true, className: "text-right", cellClassName: "tabular text-right font-semibold", render: (r) => money(r.amount) },
    { key: "paid_amount", label: "Paid", className: "text-right", cellClassName: "tabular text-right", render: (r) => money(r.paid_amount) },
    { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
  ];
  return (
    <ResourcePage title="Expenses" subtitle="Operating expenses with payment status and budget impact."
      endpoint="expenses" module="expenses" columns={columns} fields={fields}
      searchPlaceholder="Search category, vendor…" emptyHint="Log expenses to track spend vs budget." />
  );
}
